export default __webpack_public_path__ + "static/media/article04.4e1e602b.md";